import config from "../config";
import { getserviceWorker } from "../serviceWorker";
import Axios from "axios";

export const notificarme = (setIsNotificationRequire) => {
  if (!window.Notification) {
    console.log("este navegador no soporta notificaciones");
    return;
  } else {
    if (Notification.permission === "default") {
      Notification.requestPermission().then((permission) => {
        console.log(permission);
        if (permission === "granted") {
          setIsNotificationRequire(true);
        }
      });
    }
  }
};

export const GenerarSubcripcion = async () => {
  const urlBase = config.API_URL;
  const result = await Axios.get(`${urlBase}services/app/Trip/PushKey`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Abp.Tenantid": config.TENANT_ID
    },
  });
  const data = urlBase64ToUint8Array(result.data.result);

  const resultNotification = await createNotificationSubscription(data);
  return resultNotification;
};

const createNotificationSubscription = async (key) => {
  try {
    const serviceWorker = getserviceWorker();
    return serviceWorker.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: key,
    });
  } catch (err) {
    console.log(err);
  }
};

export const cancelarSubcripcion = (setSetting, setting) => {
  const serviceWorker = getserviceWorker();

  return serviceWorker.pushManager.getSubscription().then((sub) => {
    sub.unsubscribe().then(() => {
      setSetting({
        ...setting,
        notification: false,
      });
    });
  });
};

export const cancelarSubcripcionLogout = () => {
  try {
    const serviceWorker = getserviceWorker();

    return serviceWorker.pushManager.getSubscription().then((sub) => {
      sub.unsubscribe().then(() => { });
    });
  } catch (err) {
    console.log(err);
  }
};

export const tieneSubcripcion = (setting, setSetting) => {
  try {
    const serviceWorker = getserviceWorker();
    serviceWorker.pushManager.getSubscription().then((sub) => {
      if (sub === null) {
        setSetting({
          ...setting,
          notification: false,
        });
      } else {
        setSetting({
          ...setting,
          notification: true,
        });
      }
    });
  } catch (err) {
    console.log(err);
  }
};

export const tieneSubcripcionMain = () => {
  const serviceWorker = getserviceWorker();
  serviceWorker.pushManager.getSubscription().then((sub) => {
    if (sub === null) {
      return false;
    } else {
      return true;
    }
  });
};

export const enviarSubscripcion = async (subscripcion) => {
  const authKey = localStorage.getItem("key");
  Axios.post(
    `${config.API_URL}services/app/Trip/InsertUserSubscription?key=${authKey}`,
    {
      subscripcion: JSON.stringify(subscripcion),
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Abp.Tenantid": config.TENANT_ID
      },
    }
  )
    .then((res) => console.log(res.data))
    .catch((err) => {
      console.log("Error al enviar el push");
    });
};

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};
